/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export * from './colorUtils.js';
// Make sure all color files are exported
export * from './colors/baseColors.js';
export * from './colors/chartsColors.js';
export * from './colors/editorColors.js';
export * from './colors/inputColors.js';
export * from './colors/listColors.js';
export * from './colors/menuColors.js';
export * from './colors/minimapColors.js';
export * from './colors/miscColors.js';
export * from './colors/quickpickColors.js';
export * from './colors/searchColors.js';
